import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { getQrCodeDataUrlFromText } from '@timechef/core/utils/qrcode-utils';

@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QrCodeComponent implements OnChanges {
  @Input() data?: string;
  @Input() width = 200;

  qrCodeDataUrl: string | null = null;

  constructor(private cd: ChangeDetectorRef) {}
  async ngOnChanges() {
    if (!this.data || !this.width) {
      this.qrCodeDataUrl = null;
      return;
    }

    this.qrCodeDataUrl = await getQrCodeDataUrlFromText(this.data, { width: this.width, errorCorrectionLevel: 'M', margin: 0 });
    this.cd.markForCheck();
  }
}
